import React from 'react';
// ##### Komarov 2025-08-05
import { useSelector } from 'react-redux';
import { useLocalizedText } from '../../../../../hooks/useLocalizedText.js';

const ClickableLayer_01_CityOrHotel_Alert = ({ width, height }) => {
  const ChooseYourHotel = useLocalizedText('ChooseYourHotel');

  return (
    <div
      data-component="ClickableLayer_01_CityOrHotel_Alert"
      id="ClickableLayer_01_CityOrHotel_Alert"
      style={{
        gridColumn: '1',
        display: 'flex',
        flexDirection: 'row-reverse',
        justifyContent: 'space-around',
        width: width,
        height: height,
        border: 'red',
        borderWidth: '0.2em',
        borderStyle: 'solid',
        borderRadius: '1rem',
        fontFamily: 'Arial',
        alignItems: 'center',
        margin: '0.3vw',
      }}
    >
      <div
        style={{
          display: 'inline-flex',
          flexDirection: 'row',
          marginTop: '0.25em',
          color: 'red',
        }}
      >
        {ChooseYourHotel}
      </div>
    </div>
  );
};

export default ClickableLayer_01_CityOrHotel_Alert;
